import { createAction, props } from '@ngrx/store';
import { DocumentType, DocumentTypeCreate, DocumentTypeUpdate } from '../../services/model';
export const fetchDocumentTypes = createAction('[DocumentType] Fetch All');

export const loadDocumentTypes = createAction(
  '[DocumentType] Load All Success',
  props<{ documentTypes: DocumentType[] }>()
);

export const createDocumentType = createAction('[DocumentType] Create', props<{ documentType: DocumentTypeCreate }>());

export const updateDocumentType = createAction('[DocumentType] Update', props<{ documentType: DocumentTypeUpdate }>());

export const deleteDocumentType = createAction('[DocumentType] Delete', props<{ id: string }>());

export const loadDocumentTypeFailed = createAction('[DocumentType] Load Failed', props<{ error: string }>());
